export const environment = {
production: true,
occBaseUrl: 'https://api.chok-dohlergmb1-p1-public.model-t.cc.commerce.ondemand.com',
baseUrl: 'https://d-catalogue.doehler.com',
iasURL: 'https://idp.doehler.com',
clientId: '2d012ca6-7749-44a9-adf6-0f1ae59bb302',
cdcAPIKey: '3_nEhl-cCym0-RP3SDOwmSJB2iNG5nPjCpfCWAfH7lNsHx1_aYokwPqYkzsysh5Te9',
occApiPrefix: '/occ/v2/',
};